export const API_URL = process.env.REACT_APP_API_URL;

export const config = {
  API_URL: process.env.REACT_APP_API_URL,
  ALLOWED_USER_TYPES: ["1", "4", "3", "5", "18", "19"],
};

